import { inject, Injectable } from "@angular/core"
import {
  FrontendCard as Card,
  CardRequest,
  CardService,
  Deck,
  DeckService,
  DeckUpdateConfig
} from "@nx-superprep/backend/firebase"
import { from, map, Observable, tap } from "rxjs"

@Injectable({ providedIn: 'root' })
export class CardFetchingService {
  private readonly cardService = inject(CardService);
  private readonly deckService = inject(DeckService);

  fetchCards(request: CardRequest, config: DeckUpdateConfig): Observable<Card[]> {
    return this.cardService.fetchCardsByRequest(request).pipe(
      tap(cards => this.updateDeckWithFetchedCards(cards, config))
    );
  }

  updateDeckWithFetchedCards(cards: Card[], config: DeckUpdateConfig): Deck | undefined {
    // Ensure all required properties are provided
    if (!config) {
      console.error('Config is undefined in updateDeckWithFetchedCards');
      return undefined;
    }

    return this.deckService.updateData({
      cards,
      setting: config.setting,
      dayPlanModule: config.dayPlanModule,
      spacedRepConfig: config.spacedRepConfig,
      studyPhase: config.studyPhase,
      reviewIds: config.dayPlanModule?.reviewCardIds ?? []
    });
  }

  prepareCardForDisplay(card: Card): Observable<Card> {
    if (!card) {
      console.warn('Attempted to prepare undefined card for display');
      return from([]);
    }

    return from(this.cardService.assetizeCards([card], false, 4))
      .pipe(map(result => result.cards[0] as Card));
  }
}
